var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrocetta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "octicon:x-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.36998 8.13746C8.68639 7.83022 9.11529 7.65765 9.56248 7.65765C10.0097 7.65765 10.4386 7.83022 10.755 8.13746L18 15.1812L25.245 8.13746C25.4512 7.9215 25.7136 7.76362 26.0044 7.68047C26.2952 7.59731 26.6037 7.59195 26.8974 7.66496C27.1911 7.73796 27.4591 7.88662 27.6731 8.09528C27.8872 8.30394 28.0394 8.56487 28.1137 8.85058C28.1887 9.13579 28.1833 9.43535 28.0982 9.71785C28.0131 10.0004 27.8514 10.2554 27.63 10.4562L20.385 17.5L27.63 24.5437C27.8521 24.7442 28.0145 24.9993 28.1 25.282C28.1856 25.5648 28.1911 25.8647 28.116 26.1502C28.0409 26.4357 27.888 26.6963 27.6734 26.9044C27.4587 27.1125 27.1904 27.2605 26.8965 27.3328C26.6031 27.4056 26.295 27.4004 26.0044 27.3177C25.7139 27.2349 25.4515 27.0777 25.245 26.8625L18 19.8187L10.755 26.8625C10.4352 27.1526 10.0119 27.3107 9.57455 27.3033C9.13717 27.296 8.71981 27.1238 8.41048 26.8231C8.10117 26.5223 7.92406 26.1166 7.9165 25.6914C7.90895 25.2661 8.07153 24.8547 8.36998 24.5437L15.615 17.5L8.36998 10.4562C8.05397 10.1486 7.87646 9.7316 7.87646 9.29683C7.87646 8.86207 8.05397 8.44508 8.36998 8.13746Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrocetta);
export default __webpack_public_path__ + "static/media/crocetta.5d479d11b3a7649935d1f3e6465f5fcd.svg";
export { ForwardRef as ReactComponent };